import React, { Component } from 'react';
import Calendar from './Calendar';
import Dropdown from './Dropdown';
import Promo from './Promo';
import {roomsOptions} from '../config/options';

class MobileHome extends Component {

    render(){
        if(this.props.visible){
            return(
                <div className="vbmobile-home-bottomblock">
                    <Promo visible={true}/>
                    <div className="vb-checkin-box">
                        <label>Check in</label>
                        <Calendar value={this.props.dateInterval} onSelect={this.props.onDateSelect} numberOfCalendars={1}/>
                    </div>
                    <div className="vb-rooms-code">
                        <div className="vb-rooms-box">
                            <label>Rooms</label>
                            <Dropdown
                                value={this.props.roomsNumber}
                                options={roomsOptions}
                                placeholder='All rooms'
                                onChange={this.props.onRoomsChange}
                                className='vb-select-rooms'
                                name="rooms"
                            />
                        </div>
                        <div className="vb-code-box">
                            <label>Code</label>
                            <div className="vb-code">
                                <input type="text" value={this.props.code} onChange={this.props.onCodeChange} placeholder="enter code"/>
                            </div>
                        </div>
                    </div>
                    <button className="vb-search-button" onClick={this.props.onSearchData}>
                        <span>Search</span>
                        <i></i>
                    </button>
                </div>
            )
        }else{
            return false;
        }  
    }

}

export default MobileHome;